module.exports = __webpack_public_path__ + "8ca4c4068d3d7e731c4a3a429db7056c.svg";